import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './responsive.css';
import Dashboard from './pages/Dashboard.jsx';
import Workers from './pages/Workers.jsx';
import Attendance from './pages/Attendance.jsx';
import Payroll from './pages/Payroll.jsx';
import Leave from './pages/Leave.jsx';
import LeaveTypeMaster from './pages/LeaveTypeMaster.jsx';
import HolidayMaster from './pages/HolidayMaster.jsx';
import ShiftMaster from './pages/ShiftMaster.jsx';
import Reports from './pages/Reports.jsx';
import UserManagement from './pages/UserManagement.jsx';
import PaymentTerms from './pages/PaymentTerms.jsx';
import Login from './components/Login.jsx';
import { HRMSProvider } from './context/HRMSContext.jsx';
import { PermissionsProvider, usePermissions } from './context/PermissionsContext.jsx';

function AppContent() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [pageHistory, setPageHistory] = useState(['dashboard']);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { canAccessModule, loading: permissionsLoading, currentUser, setUser } = usePermissions();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && currentUser) {
      setIsAuthenticated(true);
    }
  }, [currentUser]);

  const handleLogin = async (userData, token) => {
    localStorage.setItem('token', token);
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setUser(null);
    setCurrentPage('dashboard');
    setPageHistory(['dashboard']);
  };

  const navigateToPage = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
      setPageHistory(prev => [...prev, page]);
      window.history.pushState({ page }, '', `#${page}`);
    }
  };

  if (permissionsLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  const renderPage = () => {
    try{
      switch(currentPage) {
        case 'workers': return <Workers />;
        case 'attendance': return <Attendance />;
        case 'payroll': return <Payroll />;
        case 'leave': return <Leave />;
        case 'leave-types': return <LeaveTypeMaster />;
        case 'holidays': return <HolidayMaster />;
        case 'shifts': return <ShiftMaster />;
        case 'payment-terms': return <PaymentTerms />;
        case 'reports': return <Reports />;
        case 'users': return <UserManagement />;
        default: return <Dashboard />;
      }
    } catch (error) {
      return <div className="alert alert-danger">Error loading page: {error.message}</div>;
    }
  };

  return (
    <HRMSProvider>
      <div className="hrms-app">
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
          <div className="container-fluid">
            <span className="navbar-brand">HRMS System</span>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <div className="navbar-nav me-auto">
                {canAccessModule('dashboard') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'dashboard' ? 'active' : ''}`} onClick={() => navigateToPage('dashboard')}>Dashboard</button>
                )}
                {canAccessModule('workers') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'workers' ? 'active' : ''}`} onClick={() => navigateToPage('workers')}>Workers</button>
                )}
                {canAccessModule('attendance') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'attendance' ? 'active' : ''}`} onClick={() => navigateToPage('attendance')}>Attendance</button>
                )}
                {canAccessModule('payroll') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'payroll' ? 'active' : ''}`} onClick={() => navigateToPage('payroll')}>Payroll</button>
                )}
                {canAccessModule('leave') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'leave' ? 'active' : ''}`} onClick={() => navigateToPage('leave')}>Leave</button>
                )}
                {canAccessModule('leave_types') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'leave-types' ? 'active' : ''}`} onClick={() => navigateToPage('leave-types')}>Leave Types</button>
                )}
                {canAccessModule('holidays') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'holidays' ? 'active' : ''}`} onClick={() => navigateToPage('holidays')}>Holidays</button>
                )}
                {canAccessModule('shifts') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'shifts' ? 'active' : ''}`} onClick={() => navigateToPage('shifts')}>Shifts</button>
                )}
                {canAccessModule('payment_terms') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'payment-terms' ? 'active' : ''}`} onClick={() => navigateToPage('payment-terms')}>Payment Terms</button>
                )}
                {/* {canAccessModule('reports') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'reports' ? 'active' : ''}`} onClick={() => navigateToPage('reports')}>Reports</button>
                )}
                {canAccessModule('user_management') && (
                  <button className={`nav-link btn btn-link text-white ${currentPage === 'users' ? 'active' : ''}`} onClick={() => navigateToPage('users')}>Users</button>
                )} */}
              </div>
              <div className="navbar-nav">
                <div className="dropdown">
                  <button className="btn btn-link nav-link dropdown-toggle text-white" type="button" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    {currentUser?.username}
                  </button>
                  <ul className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`}>
                    {canAccessModule('user_management') && (
                      <li><button className="dropdown-item" onClick={() => { navigateToPage('users'); setDropdownOpen(false); }}>User</button></li>
                    )}
                    {canAccessModule('reports') && (
                      <li><button className="dropdown-item" onClick={() => { navigateToPage('reports'); setDropdownOpen(false); }}>Reports</button></li>
                    )}
                    <li><hr className="dropdown-divider" /></li>
                    <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <main className="container-fluid mt-3 px-2 px-md-3">
          {renderPage()}
        </main>
      </div>
    </HRMSProvider>
  );
}

function App() {
  return (
    <PermissionsProvider>
      <AppContent />
    </PermissionsProvider>
  );
}

export default App;

